// YouTube ids for product videos.
//
// One definition per video, because two surfaces embed the Autopilot one (the landing page section
// and /features/autopilot) and a stale copy in one of them is the kind of dead embed nobody
// notices — the page still renders, it just shows the wrong film or a grey box.
//
// Setting an id to "" is the correct way to pull a video: VideoEmbed renders nothing at all for a
// falsy id, so the surrounding section collapses cleanly rather than leaving a broken player.
//
// https://youtu.be/G02H1lLzkt4 — Autopilot walkthrough (2026-10-25)
export const AUTOPILOT_VIDEO_ID = "G02H1lLzkt4";
